// File: src/components/pages/static/About.jsx
// Publicly accessible — no authentication required

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import '../../../styles/unified.css';

const About = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth0();
  const handleBack = () => navigate(isAuthenticated ? '/dashboard' : '/');

  return (
    <div className="static-page">

      {/* Hero */}
      <div className="static-hero">
        <div className="static-hero-inner">
          <button className="static-back-btn" onClick={handleBack}>
            ← {isAuthenticated ? 'Back to Dashboard' : 'Back to Home'}
          </button>
          <div className="static-hero-icon">🚗</div>
          <div className="static-hero-badge">About Us</div>
          <h1 className="static-hero-title">Who We Are</h1>
          <p className="static-hero-subtitle">
            Built by instructors, for instructors — making driving school management
            simpler, smarter, and stress-free.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="static-container">

        <div className="static-card">
          <h2 className="static-card-title">
            <span className="static-card-title-icon">💡</span>
            Our Mission
          </h2>
          <p>
            We are a forward-thinking startup committed to simplifying everyday work for
            driving instructors and schools. By reducing manual effort and optimising
            processes, we help organisations boost productivity at every level of their
            operations.
          </p>
        </div>

        <div className="static-card">
          <h2 className="static-card-title">
            <span className="static-card-title-icon">🎯</span>
            What We Do
          </h2>
          <p>
            BipzApp brings together student management, lesson scheduling, booking
            tracking, and payment recording under one roof. Whether you are an independent
            instructor managing a handful of learners or a school coordinating multiple
            instructors, BipzApp scales to fit your workflow.
          </p>
          <p>
            Every feature is designed with real instructors in mind—fast to learn, 
            reliable in practice, and built to reduce the administrative burden 
            so you can spend more time on personal or family activities.
          </p>
        </div>

        <div className="static-card">
          <h2 className="static-card-title">
            <span className="static-card-title-icon">🌱</span>
            Where We Are Headed
          </h2>
          <p>
            We are continuously evolving BipzApp based on feedback from the instructors
            who use it every day. From voice-based booking to mobile-first experiences,
            we are investing in tools that make the platform faster and more capable over
            time.
          </p>
        </div>
        {
        <div className="static-highlight">
          <div className="static-highlight-icon">📍</div>
          <p>
            BipzApp serves driving instructors and schools across the United Kingdom.
          </p>
        </div>
        }
      </div>
    </div>
  );
};

export default About;
